<template>
  <div class="container-370 text-center">
    <div class="main-title mt-40 mb-20"><p>会議の相手は？（必須）</p></div>

    <ul class="list-option-sub-partner h-159 mb-30">
      <li v-for="user in value" :key="user.id" class="mb-1 p-15">
        <span v-if="user.type === USER_TYPE_PATIENT || user.user_type === USER_TYPE_PATIENT" class="float-left">{{`${user.name || user.user_name} (患者)`}}</span>
        <span v-if="user.type === USER_TYPE_PHARMACIST || user.user_type === USER_TYPE_PHARMACIST" class="float-left">{{`${user.name || user.user_name} (薬剤師)`}}</span>
        <span v-if="user.type === USER_TYPE_OTHER || user.user_type === USER_TYPE_OTHER" class="float-left">
          {{`${user.name || user.user_name}`}}
          <span v-if="user.occupation || user.user_occupation">{{`(${user.occupation || user.user_occupation})`}}</span>
        </span>
        <span @click="removeUser(user)" class="button small error btn-delete-member">削除</span>
      </li>
    </ul>

    <a @click="back()" class="btn-add-member button mb-30 w-181 border-radius-22">
      <img src="../../../assets/icon/add-plus.png" >
      <span>参加者を追加</span>
    </a>

    <div><a @click="next" class="button success medium w-180">次へ</a></div>
  </div>
</template>

<script>
import _ from 'lodash'
import {USER_TYPE_OTHER, USER_TYPE_PHARMACIST, USER_TYPE_PATIENT} from '@/const'

export default {
  data () {
    return {
      USER_TYPE_PHARMACIST,
      USER_TYPE_PATIENT,
      USER_TYPE_OTHER
    }
  },
  props: {
    value: {type: Array}
  },
  methods: {
    removeUser (user) {
      let users = _.cloneDeep(this.value)
      _.remove(users, n => n.id === user.id)
      users = [...users]
      if (users.length === 0) {
        this.back()
      }
      this.$emit('input', users)
    },
    next () {
      this.$emit('changeStep', 'time-picker')
    },
    back () {
      this.$emit('changeStep', 'add-users', true)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/meetings/create/ConfirmUsers.vue